import type { ReactNode } from 'react';

export interface SectionCardProps {
  /** Section heading (rendered as h2). */
  title?: ReactNode;
  /** One line under the heading. */
  description?: ReactNode;
  /** Right-aligned action in the heading row, e.g. a "Change" Anchor or a small Button. */
  action?: ReactNode;
  children?: ReactNode;
  /** Anchor target (e.g. "delete" for /account#delete). */
  id?: string;
  /** Tight vertical padding for lists of rows (SummaryRow, link rows). */
  flush?: boolean;
}

/** A white (dark: blue-grey) card that groups one topic on a page. */
export function SectionCard({ title, description, action, children, id, flush }: SectionCardProps) {
  return (
    <section className={`rides-card rides-sectioncard${flush ? ' flush' : ''}`} id={id}>
      {(title || action) && (
        <div className="head" style={flush ? { marginTop: 12 } : undefined}>
          <div style={{ minWidth: 0 }}>
            {title && <h2>{title}</h2>}
            {description && <p>{description}</p>}
          </div>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}
